
export function sleep(ms=1000){
  const now = performance.now();
  while (performance.now() - now < ms){}
}

export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export function delayMock(data, ms=500, success){
  return delay(ms).then(() => {
    console.log(`mock data => `, data);
    success && setTimeout(() => {success(data);}, 10);

    return {
      code: '000000',
      data,
    };
  });
}
